import React, { Fragment } from 'react';
import { Divider } from '../common/Divider';
import { useTranslation } from 'react-i18next';
import { VerticalDivider } from '../common/VerticalDivider';

interface OperationSettlementSummaryProps {
  testId?: string;
  className?: string;
}

export const OperationSettlementSummary: React.FC<
  OperationSettlementSummaryProps
> = ({ testId, className }) => {
  const { t } = useTranslation();
  const data = [
    {
      title: 'settlement.summary.totalSettlementAmount',
      value: '5,091,8280 원',
    },
    {
      title: 'settlement.summary.totalErrorRate',
      value: '5.2194 %',
    },
    {
      title: 'settlement.summary.totalGenerators',
      value: '43 개',
    },
    {
      title: 'settlement.summary.totalAggregateCapacity',
      value: '1,903,802 MWh',
    },
    {
      title: 'settlement.summary.totalGeneration',
      value: '91,889 MWh',
    },
  ];
  return (
    <div data-testid={testId} className={`${className}`}>
      <Divider className="rounded-[5px] bg-dark-4" />
      <div className="grid h-[100px] grid-cols-5">
        {data.map(({ title, value }, index) => {
          return (
            <div key={index} className="flex items-center">
              {index === 0 ? (
                <Fragment></Fragment>
              ) : (
                <VerticalDivider className="h-[40px] bg-[#BEC4CA]" />
              )}
              <div className="ml-[30px]">
                <p className="noto-13-light leading-none text-dark-10">
                  {t(title)}
                </p>
                <p className="pop-18-bold mt-[15px] leading-none tracking-[-0.18px]">
                  {value}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      <Divider className="rounded-[5px] bg-dark-4" />
    </div>
  );
};
